import React, { useState } from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-regular-svg-icons";
import { faCommentQuestion } from "@fortawesome/pro-regular-svg-icons";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import LanguageSelector from "../molecules/LanguageSelector";
import Separator from "../atoms/Separtor";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { Permission, usePermission } from "@/shared/hooks/usePermission";
import { classNames } from "@/shared/utils/classnames";
import { useNavigate } from "react-router-dom";
import { Role, User } from "@/app/auth/auth";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { selectBranch, toggleSidebar } from "@/app/branchs/branch.slice";
import { Avatar } from "../atoms/Avatar";
import { useDispatch } from "react-redux";
import { ROLE_NAMES } from "./BranchSideBar";

type NavigationItem = {
  name: string;
  href: string;
  current: boolean;
  permission: Permission;
};

type NavbarProps = {
  navigation: NavigationItem[];
  user?: User;
  onChangeProfile: () => void;
};

const COMPANIES_NAME = "Companias";

const Navbar: React.FC<NavbarProps> = ({
  navigation,
  user,
  onChangeProfile,
}) => {
  const navigate = useNavigate();
  const [transactionFormVisible, setTransactionFormVisible] = useState(false);
  const { can } = usePermission();

  const handleCreateTransaction = () => {
    setTransactionFormVisible(true);
  };

  const handleSubmit = () => {
    console.log("submit");
  };

  const [values, setValues] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    description: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const resetForm = () => {
    setValues({
      name: "",
      description: "",
    });
    setErrors({
      name: "",
      description: "",
    });
  };

  const handleLogout = () => {
    localStorage.clear();

    const checkLocalStorageEmpty = () => {
      if (localStorage.length === 0) {
        setTimeout(() => {
          navigate("/auth/login");
          window.location.reload();
        }, 100);
      } else {
        setTimeout(checkLocalStorageEmpty, 100); // Vuelve a verificar después de 100 ms
      }
    };

    checkLocalStorageEmpty();
  };

  const dispatch = useDispatch();

  const branch = useSelector(selectBranch);
  const openSideBarBranch = () => {
    console.info("hello");
    dispatch(toggleSidebar(true));
  };

  return (
    <Disclosure as="nav" className="bg-gray-800">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8  z-100">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            {/* Mobile menu image and button */}
            <div className="flex items-center pr-5">
              {branch?.logo ? (
                <Avatar
                  onClick={openSideBarBranch}
                  src={
                    branch?.logo
                      ? `https://dash.fitmewise.com/uploads/branchs/${branch.logo}`
                      : "https://dash.fitmewise.com/uploads/branchs/default.png"
                  }
                  style={{ width: 30, height: 30 }}
                  className="rounded-xl"
                />
              ) : (
                <Avatar
                  onClick={openSideBarBranch}
                  src={"https://dash.fitmewise.com/uploads/branchs/default.png"}
                  style={{ width: 30, height: 30 }}
                  className="rounded-xl"
                />
              )}
              {/* <div className="bg-gray-300 animate-pulse w-16 h-16 rounded-xl" /> */}
              <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <FontAwesomeIcon
                  icon={faBars}
                  className="block h-6 w-6 group-data-[open]:hidden"
                />
                <FontAwesomeIcon
                  icon={faXmark}
                  className="hidden h-6 w-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>
          </div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex flex-shrink-0 items-center">
              <img
                alt="fitmewise"
                src="/logo-default.png"
                className="h-8 w-auto"
              />
            </div>
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {navigation.map((item) => {
                  if (
                    item.name === COMPANIES_NAME &&
                    user?.role === (ROLE_NAMES.SUPER_ADMIN as unknown as Role)
                  ) {
                    return (
                      <button
                        key={item.name}
                        onClick={() => navigate(item.href)}
                        aria-current={item.current ? "page" : undefined}
                        className={classNames(
                          item.current
                            ? "bg-gray-900 text-white"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "rounded-md px-3 py-2 text-sm font-medium"
                        )}
                      >
                        {item.name}
                      </button>
                    );
                  }

                  return (
                    item.permission &&
                    can(item.permission) && (
                      <button
                        key={item.name}
                        onClick={() => navigate(item.href)}
                        aria-current={item.current ? "page" : undefined}
                        className={classNames(
                          item.current
                            ? "bg-gray-900 text-white"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "rounded-md px-3 py-2 text-sm font-medium"
                        )}
                      >
                        {item.name}
                      </button>
                    )
                  );
                })}
              </div>
            </div>
          </div>

          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <button
              type="button"
              className="relative rounded-full bg-gray-800 pt-1.5 px-1.5 pb-.5 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
              onClick={() => navigate("/chat")}
            >
              <span className="absolute -inset-1.5" />
              <span className="sr-only">Chat</span>
              <FontAwesomeIcon icon={faComments} className="h-6 w-6" />
            </button>
            <button
              type="button"
              className="relative rounded-full bg-gray-800 pt-1.5 px-1.5 pb-.5 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 ml-2"
              onClick={() => navigate("/faq")}
            >
              <span className="absolute -inset-1.5" />
              <span className="sr-only">Chat Support</span>
              <FontAwesomeIcon icon={faCommentQuestion} className="h-6 w-6" />
            </button>

            {/* Profile dropdown */}
            <Menu as="div" className="relative ml-2">
              <div>
                <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <img
                    alt=""
                    src={user?.avatar}
                    className="h-8 w-8 rounded-full"
                  />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-50 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                  >
                    {user?.name} - {user?.role}
                  </a>
                </MenuItem>
                <Separator />
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                    onClick={onChangeProfile}
                  >
                    {t("share.layouts.profiles")}
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    onClick={handleCreateTransaction}
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                  >
                    {t("user.views.change_password")}
                  </a>
                </MenuItem>
                <Separator />
                <LanguageSelector />
                <Separator />
                <MenuItem>
                  <a
                    onClick={handleLogout}
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                  >
                    {t("share.layouts.out")}
                  </a>
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>

      <DisclosurePanel className="sm:hidden">
        <div className="space-y-1 px-2 pb-3 pt-2">
          {navigation.map((item) => (
            <DisclosureButton
              key={item.name}
              as="button"
              onClick={() => navigate(item.href)}
              aria-current={item.current ? "page" : undefined}
              className={classNames(
                item.current
                  ? "bg-gray-900 text-white"
                  : "text-gray-300 hover:bg-gray-700 hover:text-white",
                "block rounded-md px-3 py-2 text-base font-medium"
              )}
            >
              {item.name}
            </DisclosureButton>
          ))}
        </div>
      </DisclosurePanel>

      <DialogCreate
        OnclickCreate={handleSubmit}
        OnclickCancel={() => {
          resetForm();
          setTransactionFormVisible(false);
        }}
        isLoading={true}
        tittleButtonCreate={t("general.create")}
        tittleButtonCancel={t("general.cancel")}
        open={transactionFormVisible}
        setOpen={() => setTransactionFormVisible(false)}
        tittle={t("user.views.password")}
        subTittle={t("user.views.change_password")}
      >
        <form action="">
          <div className="mt-6 mx-2">
            <div className="space-y-12">
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("user.views.password")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                  <div className="col-span-full">
                    <InputWithCornerHint
                      label={t("user.views.password")}
                      name="name"
                      type="text"
                      placeholder={t("user.views.password")}
                      onChange={handleChange}
                      error={!!errors.name}
                      textError={errors.name}
                      value={values.name}
                    />
                  </div>
                  <div className="col-span-full">
                    <InputWithCornerHint
                      label={t("user.views.password")}
                      name="description"
                      error={!!errors.description}
                      textError={errors.description}
                      onChange={handleChange}
                      value={values.description}
                      type="text"
                      placeholder={t("user.views.password")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </DialogCreate>
    </Disclosure>
  );
};

export default Navbar;
